import { render, staticRenderFns } from "./editTheatreInfo.vue?vue&type=template&id=ba0fd10a&scoped=true&"
import script from "./editTheatreInfo.vue?vue&type=script&lang=js&"
export * from "./editTheatreInfo.vue?vue&type=script&lang=js&"
import style0 from "./editTheatreInfo.vue?vue&type=style&index=0&id=ba0fd10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0fd10a",
  null
  
)

export default component.exports